import CartIcon from '../../assets/icons/CartIcon';
import useBasket from '../../hooks/basket/useBasket';
import useTheme from '../../hooks/ui/useTheme';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { ButtonTypes } from '../../services/exports/Interfaces';

const OrderBasketButton = () => {
  const { basketItemsCount } = useBasket();
  const { toggleOrderBasketModal } = useAppMethods();
  const theme = useTheme();
  return (
    <button
      className="bg-brand-button-primary-background px-sm h-[36px] rounded-[16px] flex items-center gap-xs"
      onClick={() => {
        toggleOrderBasketModal({
          openModal: true,
        });
      }}
    >
      <CartIcon color={theme.buttons[ButtonTypes.primary].text} className="h-[20px] w-[20px]" />
      <h6 className="text-brand-button-primary-text text-[16px]">{basketItemsCount}</h6>
    </button>
  );
};

export default OrderBasketButton;
